import { Link } from "react-router-dom";
import { Users, Code2, MonitorSmartphone, ArrowRight } from "lucide-react";
import { RUSH_TIMELINE } from "../../data/content";
import { track } from "../../lib/api";

export default function RushHourShowcase() {
  return (
    <section className="py-24 lg:py-36 border-t border-white/5 bg-navy-900/50" data-testid="rush-showcase-section">
      <div className="container-x">
        <div className="flex items-center gap-3">
          <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse-dot" />
          <p className="section-label">RUSH HOUR — THE SIGNATURE PRODUCT</p>
        </div>
        <h2 className="mt-5 font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-white max-w-4xl">
          YOUR APPLICATION.<br /><span className="text-flame">BUILT LIVE.</span>
        </h2>
        <p className="mt-6 text-slate-400 max-w-2xl leading-relaxed">
          Sit with our developer. Explain the business requirement. Watch the application take shape. Test it.
          Request changes. See those changes implemented. Leave with your software.
        </p>

        {/* Timeline */}
        <div className="mt-16 rounded-2xl border border-white/10 bg-navy-800 p-6 sm:p-10 overflow-x-auto">
          <div className="flex min-w-[720px] items-start justify-between relative">
            <div className="absolute top-[7px] left-0 right-0 h-px bg-white/10" />
            {RUSH_TIMELINE.map((t, i) => (
              <div key={t.time} className="relative flex flex-col items-center text-center flex-1" data-testid={`rush-timeline-${i}`}>
                <span className={`w-3.5 h-3.5 rounded-full border-2 ${i === 2 ? "bg-flame border-flame animate-pulse-dot" : "bg-navy border-flame/60"} relative z-10`} />
                <p className="mt-4 font-mono text-sm font-bold text-flame">{t.time}</p>
                <p className="mt-1 font-mono text-[10px] tracking-[0.15em] text-slate-400 max-w-[90px]">{t.label}</p>
              </div>
            ))}
          </div>
          <p className="mt-8 text-[11px] text-slate-600 font-mono">Illustrative workflow. Actual duration depends on project scope and complexity.</p>
        </div>

        {/* Formula */}
        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {[
            { icon: Users, title: "CLIENT + STAKEHOLDERS", desc: "Explain, review, test, request changes — live." },
            { icon: Code2, title: "VIBE CODING SPECIALIST", desc: "Designs, codes, integrates and deploys in the session." },
            { icon: MonitorSmartphone, title: "LIVE APPLICATION", desc: "A working product by the end of the engagement." },
          ].map((c, i) => (
            <div key={c.title} className="rounded-xl border border-white/10 bg-navy-800 p-7 card-lift">
              <c.icon className="w-6 h-6 text-flame" />
              <p className="mt-4 font-heading font-bold text-sm tracking-wide text-white">{c.title}</p>
              <p className="mt-2 text-xs text-slate-400 leading-relaxed">{c.desc}</p>
              {i < 2 && <span className="hidden md:block absolute" />}
            </div>
          ))}
        </div>

        <Link
          to="/rush-hour"
          data-testid="rush-showcase-cta"
          onClick={() => track("rush_hour_click", { location: "showcase" })}
          className="mt-12 inline-flex items-center gap-2 font-heading font-bold text-flame tracking-wide hover:gap-3 transition-all"
        >
          EXPLORE RUSH HOUR <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  );
}
